import CityPageTemplate from "@/pages/city-template/CityPageTemplate";
import { syracuseConfig } from "./data";

export default function SyracusePage() {
  return <CityPageTemplate config={syracuseConfig} />;
}